<template>
	<transition name="fadeHeight">
		<div class="modal_holder" v-if="visible" v-bind:class="modalComponent">
			<div class="modal_overlay" @click="hideModal()"></div>

			<div class="modal_content">
				<div class="modal_content_inner">
					<component :is="component"></component>
				</div>
			</div>
		</div>
	</transition>
</template>


<script>
import { defineComponent, defineAsyncComponent, markRaw } from 'vue';
import { mapState, mapActions } from 'vuex';

//imports have to stay 
import ModalWarning from './ModalWarning.vue';
import ModalConfirm from './ModalConfirm.vue';
import ModalError from './ModalError.vue';
import ModalImage from './ModalImage.vue';

export default defineComponent({
	name: 'Modal',
	data() {
		return {
			component: null
		};
	},
	methods: {
		...mapActions(['hideModal'])
	},
	computed: {
		visible() {
			return this.$store.getters.getModalVisible;
		},
		modalComponent() {
			return this.$store.getters.getModalComponent;
		}
	},
	watch: {
		modalComponent(componentPath) {
			if (!componentPath) return;

			const component = defineAsyncComponent(() => import(`./${componentPath}.vue`));
			this.component = markRaw(component);
		}
	},
	created() {
		document.onkeydown = evt => {
			evt = evt || window.event;
			if (evt.keyCode == 27) {
				this.hideModal();
			}
		};
	}
});
</script>


<style lang="scss" scoped>

/* Transicije */
.fadeHeight-enter-active,
.fadeHeight-leave-active {
	transition: all 0.3s;
}

.fadeHeight-enter,
.fadeHeight-leave-to {
	opacity: 0;
}
</style>
